import type { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

import type { ProviderFieldError } from '@/domain/providerConfig';

const REQUIRED_CODES: ReadonlySet<string> = new Set(['required', 'newPenSecretRequired']);

/**
 * The client errors to mark now, and the "still empty" ones to hold back. As for a new SCADA
 * row (N8), an empty required box is not marked red until the user has typed in it or left
 * it: Connect alone turns nothing red. Its "(required)" mark shows, and Test and Save still
 * wait for it.
 */
export function splitQuietRequired<T extends FieldValues>(
    form: UseFormReturn<T>,
    errors: readonly ProviderFieldError[],
    isPath: (path: string) => path is FieldPath<T>
): { shown: ProviderFieldError[]; quiet: ProviderFieldError[] } {
    const shown: ProviderFieldError[] = [];
    const quiet: ProviderFieldError[] = [];
    for (const error of errors) {
        if (!REQUIRED_CODES.has(error.code) || !isPath(error.path)) {
            shown.push(error);
            continue;
        }
        // Passing formState subscribes the card to dirty and touched changes.
        const state = form.getFieldState(error.path, form.formState);
        (state.isDirty || state.isTouched ? shown : quiet).push(error);
    }
    return { shown, quiet };
}
